import React from 'react';
import { Modal } from './Modal';

const ModalWithTimer = ({ children, time, breakpoint, noAnimation = false }) => {
  return (
    <Modal breakpoint={breakpoint} timer={time} withoutCloseButton withoutOutsideClose noAnimation={noAnimation}>
      {children}
    </Modal>
  );
};

export default ModalWithTimer;
